import React from 'react';
import ReactEDSWrapper from '../../../utils/react-eds-wrapper';
import { Datepicker } from '@dsi/react-eds';
import styles from './DateRangePicker.module.css';

export function toDateString(d: Date): string {
  return d.toISOString().slice(0, 10);
}

export function getToday(): string {
  return toDateString(new Date());
}

export function getTwelveMonthsAgo(): string {
  const d = new Date();
  d.setMonth(d.getMonth() - 12);
  return toDateString(d);
}

interface DateRangePickerProps {
  startDate: string;
  endDate: string;
  onStartDateChange: (value: string) => void;
  onEndDateChange: (value: string) => void;
}

const DateRangePicker: React.FC<DateRangePickerProps> = ({ startDate, endDate, onStartDateChange, onEndDateChange }) => {
  const minDate = getTwelveMonthsAgo();
  const maxDate = getToday();

  const handleStartSelect = (value: string) => {
    onStartDateChange(value);
    if (value && endDate && value > endDate) {
      onEndDateChange(value);
    }
  };

  const handleEndSelect = (value: string) => {
    onEndDateChange(value);
    if (value && startDate && value < startDate) {
      onStartDateChange(value);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.field}>
        <label>Start Date</label>
        <ReactEDSWrapper
          key={startDate}
          component={Datepicker}
          min={minDate}
          max={maxDate}
          initialViewDate={startDate || minDate}
          onDateSelect={handleStartSelect}
        >
          {startDate}
        </ReactEDSWrapper>
      </div>
      <div className={styles.field}>
        <label>End Date</label>
        <ReactEDSWrapper
          key={endDate}
          component={Datepicker}
          min={minDate}
          max={maxDate}
          initialViewDate={endDate || maxDate}
          onDateSelect={handleEndSelect}
        >
          {endDate}
        </ReactEDSWrapper>
      </div>
    </div>
  );
};

export default DateRangePicker;
